import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetLoginService {
  private recoveryHash: string;
  private showLoginDialog: boolean;

  getRecoveryHash(): string {
    return this.recoveryHash;
  }

  setRecoveryHash(hash: string): void {
    this.recoveryHash = hash;
  }

  setShowLoginDialog(show: boolean): void {
    this.showLoginDialog = show;
  }

  getShowLoginDialog(): boolean {
    return this.showLoginDialog;
  }
}
